import styled from "styled-components";
import { spacing } from "@styling/sizing";

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.x1}px;
`;
